import moment from 'moment-timezone';

const readDate = (date, timeZone) => {
    return moment(date).tz(timeZone).format("YYYY-MM-DD HH:mm:ss");
}

export { readDate };
